import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutPnnLaneBuilderProfileList extends Layout {
    buttonRunProfile: Button;
    layoutheaderLaneBuilder: LayoutHeader;
    sourcePnnBuilderProfile: DataSource;
    sourcePnnLaneBuilder: DataSource;
    tableLaneBuilder: Table;
}
